import { CSSProperties } from 'react'
import Image from 'next/image'

import { ImageSource } from '../../utils/types/Types'

import styles from './ImageCard.module.scss'

type Props = {
	imageSource: ImageSource
	style?: CSSProperties
}

const ImageCard = ({ imageSource, style }: Props) => {
	return (
		<div
			className={styles.imageContainer}
			style={{
				marginBottom: imageSource.imageOffset ? imageSource.imageOffset?.y : 0,
				...style,
			}}
		>
			<Image
				className={styles.image}
				src={imageSource.src}
				alt={imageSource.alt}
				width={imageSource.width}
				height={imageSource.height}
				priority
			/>
		</div>
	)
}

export default ImageCard
